import { RampSettings, RampCurve } from "../types/ramp";

export const revenueRampPresets = {
  conservative: [0.7, 0.8, 0.9, 1.0] as RampCurve,
  standard: [0.8, 0.9, 1.0, 1.0] as RampCurve,
  ambitious: [0.85, 1.0, 1.0, 1.0] as RampCurve,
};

export const costRampPresets = {
  conservative: [1.15, 1.1, 1.0, 1.0] as RampCurve,
  standard: [1.1, 1.05, 1.0, 1.0] as RampCurve,
  ambitious: [1.08, 1.02, 1.0, 1.0] as RampCurve,
};

export function createDefaultRampSettings(): RampSettings {
  return {
    revenueRamp: revenueRampPresets.standard,
    costRamp: costRampPresets.standard,
    applyCostRamp: {
      departmental: true,
      undistributed: true,
      otherOpex: true,
      payroll: true,
      exclude: ["depreciation", "interest", "capex", "rent"],
    },
    toplineGrowthPct: 3,
    inflationPct: 2,
    depreciationPctOfCapex: 3,
  };
}
